import { Autocomplete, CircularProgress, Grid, InputLabel, Stack, TextField } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { GenericTableColumn } from 'inside-fifa/api/generic-tables/dto';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { UpdateConfigDialogFormValues } from '../../dto';

export const SpecialTreatmentColumn = () => {
    const { values, setFieldValue } = useFormikContext<UpdateConfigDialogFormValues>();

    const columnOptions = values.config.columns ?? [];

    const selectedColumnOption = useMemo(
        () => columnOptions.find((option) => option.key === values.config.columnTitle) || null,
        [columnOptions, values.config.columnTitle],
    );

    const selectedKeyAttributeOption = useMemo(
        () => columnOptions.find((option) => option.key === values.config.keyAttributeColumn) || null,
        [columnOptions, values.config.keyAttributeColumn],
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} rowGap={3}>
                <Stack spacing={1}>
                    <InputLabel>
                        <FormattedMessage id="inside-fifa.generic-tables.special-treatment.column-title" />
                    </InputLabel>
                    {values.config ? (
                        <Autocomplete<GenericTableColumn>
                            options={columnOptions}
                            getOptionLabel={(option) => `${option.title} (id: ${option.key})`}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(_event, value) => {
                                if (value?.key === undefined) {
                                    setFieldValue('config.columnTitle', '');
                                    return;
                                }
                                setFieldValue('config.columnTitle', value.key);
                            }}
                            value={selectedColumnOption}
                        />
                    ) : (
                        <CircularProgress color="inherit" size={32} />
                    )}
                </Stack>
            </Grid>
            <Grid item xs={12} rowGap={3}>
                <Stack spacing={1}>
                    <InputLabel>
                        <FormattedMessage id="inside-fifa.generic-tables.special-treatment.key-attribute-column" />
                    </InputLabel>
                    {values.config ? (
                        <Autocomplete<GenericTableColumn>
                            options={columnOptions}
                            getOptionLabel={(option) => `${option.title} (id: ${option.key})`}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(_event, value) => {
                                if (value?.key === undefined) {
                                    setFieldValue('config.keyAttributeColumn', '');
                                    return;
                                }
                                setFieldValue('config.keyAttributeColumn', value.key);
                            }}
                            value={selectedKeyAttributeOption}
                        />
                    ) : (
                        <CircularProgress color="inherit" size={32} />
                    )}
                </Stack>
            </Grid>
        </Grid>
    );
};
